import { plugin, defaultConfig } from "@formkit/vue";
import { createProPlugin, inputs } from "@formkit/pro";
import { booleanCheck } from "vacv-components";
// add into env file
const pro = createProPlugin("fk-b6002bac46", inputs);

const config = defaultConfig({
  // Define the active locale
  plugins: [pro],
  rules: {
    booleanCheck,
  },
});

export { plugin, config };
